import type { GetServerSideProps } from "next";
import { ApiService } from "services/server";
import { Books } from "views";
import { normalizeBooks } from "utils/normalizer";
import { Formatter } from "utils/formatter";
import { is404, isCorrectLocale } from "utils/newFunction";

const SIZE = 4;

function BooksPage({ data }) {
  return <Books data={data} />;
}

export const getServerSideProps: GetServerSideProps = async ({
  params,
  query,
  locale,
}) => {
  let noIndex = false;
  const tagTreeCode = (params?.slug?.[0] || "") as string;
  const slug = (params?.slug?.[1] || "") as string;
  const apiService = new ApiService(locale);
  const page = Number.isNaN(+query.page) ? 1 : +query.page;

  try {
    const requests = [
      apiService.getGeneral(
        { tagTreesCode: [tagTreeCode] },
        { formatter: false }
      ),
      apiService.getBooks(
        {
          size: SIZE,
          offset: (page - 1) * SIZE,
          tagTreesCode: [tagTreeCode],
        },
        { formatter: false }
      ), // 0
    ];

    let response = [];
    try {
      response = await ApiService.multipleRequest(requests);
    } catch (e) {}
    const totalPagesCount = Math.ceil((response?.[1]?.count || 0) / SIZE);

    if (page > totalPagesCount) {
      noIndex = true;
    }

    if (is404(response?.[0])) {
      return {
        notFound: true,
      };
    }

    const general = Formatter.formatData({ data: response?.[0] })?.[0] || null;
    if (!isCorrectLocale(general, locale)) {
      return {
        notFound: true,
      };
    }

    if (general?.metaTag?.slug && general?.metaTag?.slug !== slug) {
      return {
        redirect: {
          permanent: true,
          destination: `${
            locale === "en" ? "/en" : ""
          }/books/${tagTreeCode}/${encodeURIComponent(general?.metaTag?.slug)}`,
        },
      };
    }

    if (general?.noIndex?.value) {
      noIndex = true;
    }

    return {
      props: {
        data: {
          books: normalizeBooks(response?.[1]),
          breadcrumb: general?.breadcrumb || [],
          title: general?.title?.value || "",
          totalPagesCount,
          page,
          metaTag: general?.metaTag || {},
          changeLanguageLink: general?.changeLanguageLink?.value || "",
          noIndex,
        },
      },
    };
  } catch (err) {
    return {
      redirect: {
        destination: "/500",
        permanent: false,
      },
    };
  }
};

export default BooksPage;
